<td>
  <span class="flex gap-2 align-items-center"
    ><i class="fas fa-book-open"></i> {{ item.title }}</span
  >
</td>
<td>
  <span class="flex gap-2">
    <p-button
      class="ml-auto"
      styleClass="p-button-xs"
      pTooltip="Im Atlas anzeigen"
      (click)="openInAtlas(item)"
      [rounded]="true"
      icon="fas fa-laptop-code"></p-button>
    <a
      *ngIf="actions.includes('edit')"
      pButton
      class="p-button-xs"
      (click)="closeParent()"
      [routerLink]="[{ outlets: { bearbeiten: ['themen', item._id] } }]"
      [rounded]="true"
      icon="fas fa-pen"></a>
  </span>
</td>
